// extracted by mini-css-extract-plugin
export default {"wrapper":"LandscapeIndicatorContributionOrganism_wrapper__wJoEv"};